<template>
    <div class="dispensing-item-preview">
        <v-btn :disabled="readOnlyRules" color="primary" small outlined rounded @click="switchToAeTab()">{{
            t('patients::button.fill_in_ae_form')
        }}</v-btn>
    </div>
</template>

<script>
export default {
    props: {
        readOnlyRules: {
            type: Boolean,
            required: true,
            default: false,
        },
    },
    data() {
        return {};
    },
    computed: {
        patientId() {
            return this.$store.state.patients.patient.id;
        },
        adverseEventId() {
            return this.$store.state.patients.patient.dispensing.adverse_event_id;
        },
    },
    created() {},
    mounted() {},
    methods: {
        switchToAeTab() {
            if (!this.patientId || !this.adverseEventId) {
                return;
            }
            this.$store.dispatch('patients/changeTab', 6);
            this.$store.dispatch('adverse_event/loadAdverseEvent', {
                patient_id: this.patientId,
                id: this.adverseEventId,
            });
        },
    },
};
</script>
